import { Pipe, PipeTransform } from '@angular/core';

import { FilterOutSelectedItemsPipe } from './filter-out-selected-items.pipe';
import { WholesalerUnableToTransferPipe } from './wholesaler-unable-to-transfer.pipe';
import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'wholesalerUnableToTransferDevicesExist',
    standalone: false
})
export class WholesalerUnableToTransferDevicesExistPipe implements PipeTransform {

  transform(bomModels: IBomModel[],
            bomModelsAccessories: IBomModel[],
            selectedItems: number[],
            selectedItemsAccessories: number[]): boolean {
    const filterSelectedItems = new FilterOutSelectedItemsPipe().transform(bomModels, selectedItems, 'id');
    const unableTransferToWholesalerDevicesExist = new WholesalerUnableToTransferPipe().transform(filterSelectedItems)?.length > 0;

    const filterSelectedAccessories = new FilterOutSelectedItemsPipe().transform(bomModelsAccessories, selectedItemsAccessories, 'id');
    const unableTransferToWholesalerAccessoriesExist = new WholesalerUnableToTransferPipe()
      .transform(filterSelectedAccessories)?.length > 0;

    return unableTransferToWholesalerDevicesExist || unableTransferToWholesalerAccessoriesExist
  }

}
